import React from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, TableCell, TableRow, Typography } from '@mui/material';import { DealGroup, SimplifiedAttioValuation } from 'dashboard409a/services/attio.types';
import { dealGroupCellSx, dealGroupToggleSx, getDealGroupRowSx } from './CollapsibleTableRow.styles';

export interface CollapsibleTableRowProps {
  group: DealGroup;
  colSpan: number;
  rowIndexStart: number;
  renderChildRows: (valuations: SimplifiedAttioValuation[], rowIndexStart: number) => React.ReactNode;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

const CollapsibleTableRow = ({
  group,
  colSpan,
  rowIndexStart,
  renderChildRows,
  isCollapsed = false,
  onToggleCollapse,
}: CollapsibleTableRowProps) => {
  const expanded = !isCollapsed;
  const displayName = group.deal_name ?? 'No deal';
  const count = group.valuations.length;

  return (
    <>
      <TableRow sx={getDealGroupRowSx(expanded)}>
        <TableCell colSpan={colSpan} sx={dealGroupCellSx}>
          <IconButton
            size="small"
            onClick={onToggleCollapse}
            aria-expanded={expanded}
            sx={dealGroupToggleSx}
          >
            {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </IconButton>
          <Typography component="span" variant="body2" sx={{ fontWeight: 600 }}>
            {displayName}
          </Typography>
          <Typography component="span" variant="body2" sx={{ ml: 0.75, color: 'text.secondary', fontWeight: 400 }}>
            ({count} valuation{count > 1 ? 's' : ''})
          </Typography>
        </TableCell>
      </TableRow>
      {expanded && renderChildRows(group.valuations, rowIndexStart)}
    </>
  );
};

export default CollapsibleTableRow;